import type { AnalyticsFeeder, ReportingReportView } from "@/lib/api";
import { CATALOGUE_FILTERS, readReportFilters, visibleReportFeeders } from "@/lib/report-filters";

export const STANDARD_READING_COLUMNS = [
  "feeder_id", "device_timestamp_at", "device_timestamp_wat", "controller_id",
  "meter_numeric_id", "v_l12_x100", "v_l23_x100", "v_l31_x100",
  "a_l1_x100", "a_l2_x100", "a_l3_x100", "active_power_inst_x10", "frequency_x100",
];

export function workbookScope(feeders: readonly AnalyticsFeeder[]): ReportingReportView {
  const programs = [...new Set(feeders.map((feeder) => feeder.program_id).filter(Boolean))];
  return workbookView(readReportFilters(new URLSearchParams({
    program: programs.length === 1 ? programs[0]! : "", groupby: "DISCO",
  })));
}

export function workbookView(filters: ReturnType<typeof readReportFilters>): ReportingReportView {
  return {
    report: "executive",
    filters: Object.fromEntries([
      ...CATALOGUE_FILTERS.map(({ key }) => [key, filters[key]]),
      ["groupby", filters.groupby],
    ]) as ReportingReportView["filters"],
  };
}

export function workbookFeeders(view: ReportingReportView, feeders: readonly AnalyticsFeeder[]): string[] {
  return visibleReportFeeders(feeders, { ...view.filters, from: "now-1d", to: "now" })
    .map((feeder) => feeder.dev_eui);
}

/** Calendar presets are WAT, independent of the operator's browser timezone. */
export function completedWatPeriod(days: 1 | 7, now = Date.now()): { from_time: string; to_time: string } {
  const local = new Date(now + 3600000);
  const end = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate()) - 3600000;
  return { from_time: new Date(end - days * 86400000).toISOString(), to_time: new Date(end).toISOString() };
}
